//#region frontend/islands/autoplay-video.js
var AutoplayVideo = class extends HTMLElement {
	connectedCallback() {
		this.video = this.querySelector("video");
		if (!this.video) return;
		const poster = this.querySelector("img");
		if (poster) this.video.addEventListener("playing", () => {
			poster.style.display = "none";
		}, { once: true });
		this.loadObserver = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				this.video.preload = "auto";
				this.loadObserver.disconnect();
			}
		}, { rootMargin: "300px 0px" });
		this.loadObserver.observe(this);
		this.observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) this.video.play().catch(() => {});
			else this.video.pause();
		}, { threshold: 0 });
		this.observer.observe(this);
	}
	disconnectedCallback() {
		this.loadObserver?.disconnect();
		this.observer?.disconnect();
	}
};
customElements.define("autoplay-video", AutoplayVideo);
//#endregion
